<template>
  <div class='editable-cell'>
    <div v-if="editable" class='editable-cell-input-wrapper'>
      <a-input
        :value="value"
        ref="input"
        @change="handleChange"
        @pressEnter="check"
        style="width: 70%; margin-right: 10px;"
      /><a-icon
      type='check'
      class='editable-cell-icon-check'
      @click="check"
    />
    </div>
    <div v-else :class="{ gray: !checked }">
      {{value || ' '}}
      <a-icon type='edit' class='editable-cell-icon' @click="edit"/>
      <a-icon v-if="!checked" type='check-circle-o' class='editable-cell-icon' @click="check"/>
    </div>
  </div>
</template>
<script>
import '../config/global'
const axios = require('axios')
export default {
  props: {
    nickname: String,
    chatroomname: String,
    dataIndex: String,
    display_nick: String
  },
  data () {
    // console.log('!!this.display_nick', this.display_nick)
    return {
      editChatroomExtUrlPostFix: 'UChatroom/edit_chatroom_ext',
      value: this.nickname || this.display_nick,
      editable: false,
      checked: this.display_nick
    }
  },
  computed: {
    editChatroomExtUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.editChatroomExtUrlPostFix
    }
  },
  watch: {
    nickname: function (newValue, oldValue) {
      // console.log('text', newValue, oldValue)
      this.value = this.nickname || this.display_nick
    },
    display_nick: function (newValue, oldValue) {
      // console.log('text', newValue, oldValue)
      this.value = this.nickname || this.display_nick
      this.checked = this.display_nick
    }
  },
  methods: {
    handleChange (e) {
      const value = e.target.value
      this.value = value
      // console.log('handleChange value', this.value)
    },
    check () {
      console.log('check')
      this.editable = false
      console.log('check value first', this.value)
      axios.post(this.editChatroomExtUrl, {
        chatroomname: this.chatroomname,
        display_nick: this.value,
        token: sessionStorage.token
      }).then((data) => {
        console.log('data.err_code:', data.data.err_code)
        if (data.data.err_code === 0) {
          console.log('check value', this.value)
          this.$emit('change', this.value, this.chatroomname, this.dataIndex)
          // console.log('check promise text', this.text)
          // this.value = this.text
          this.value = data.data.content.chatroom_ext.display_nick
          this.checked = true
        } else if (data.data.err_code === 50002) {
          console.log('token 不对，跳转登录')
          this.$router.push('/')
        }
      })
    },
    edit () {
      this.editable = true
      this.$nextTick(function () {
        this.$refs.input.focus()
      })
    }
  }
}
</script>

<style>
  .gray {
    color: rgba(0, 0, 0, 0.45);
  }
</style>
